import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { VStack } from 'tio-ui/components/layout';
import Heading from 'tio-ui/components/heading';
import ContributionTimeline from 'tio-employee/components/reimagined/contribution-timeline';
import type { ContributionHistoryData } from 'tio-employee/services/reimagined-data';

interface SlrPaymentHistorySignature {
  Args: {
    model: ContributionHistoryData | undefined;
  };
}

export default class SlrPaymentHistoryRouteComponent extends Component<SlrPaymentHistorySignature> {
  get payments() {
    return this.args.model?.payments ?? [];
  }

  <template>
    {{! template-lint-disable no-bare-strings }}
    <VStack class="w-full min-w-0 gap-4">
      <div class="tio-row-between">
        <Heading @level={{1}} class="app-page-title">Payment History</Heading>
        <LinkTo
          @route="authenticated.slr.dashboard"
          class="tio-text-sm-medium tio-fg-info hover:tio-fg-info-body"
        >
          Back to dashboard
        </LinkTo>
      </div>

      <ContributionTimeline @payments={{this.payments}} />
    </VStack>
  </template>
}
